<template>
  <div class="mt-n6">
    <my-services class="div-my-service" :serviceInfo="index.section2"></my-services>
    <my-announcement class="div-my-announcement"></my-announcement>
  </div>
</template>

<script>
import MyServices from '../components/MyServices.vue';
import MyAnnouncement from '../components/MyAnnouncement.vue';
import { defaultCustomerIndex, getCustomerIndex } from '../models/content';

export default {
    components: {
        MyServices,
        MyAnnouncement
    },
    data: () => ({
      index: defaultCustomerIndex()
    }),
    async mounted(){
      this.index = await getCustomerIndex();
    }
};
</script>